import { ContactFieldKeyType, GenericUIConfigurationType } from '../../@types';

export const ContactFieldMap: GenericUIConfigurationType<ContactFieldKeyType> =
  {
    meta: {
      label: 'contactInformation',
    },
    fields: {
      firstName: {
        name: 'firstName',
        label: 'firstName',
        className: 'ShortTextControl',
      },
      lastName: {
        name: 'lastName',
        label: 'lastName',
        className: 'ShortTextControl',
      },
      fullName: {
        name: 'fullName',
        label: 'fullName',
        className: 'LongTextControl',
      },
    },
  };
